import React from 'react';
import { Toaster } from 'react-hot-toast';
import { SimpleArchitectural } from '@/pages/SimpleArchitectural';

function App() {
  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#1f2937',
          },
        }}
      />
      <SimpleArchitectural />
    </>
  );
}

export default App;